module.exports = __webpack_public_path__ + "img/buyin.c2b84293.svg";